import "shared/extensions/number";

type DayNumberProps = {
  day: number;
};

export const DayNumber = ({ day }: DayNumberProps) => {
  return <div className="text-sm -rotate-45 text-sky-grey">{day.asOrdinal()}</div>;
};
